// extracted by mini-css-extract-plugin
module.exports = {"styledEntityDetails":"mE2uPhPo","content":"Itotw2iJ","chartWrapper":"DbUmN4A_","horizonLabel":"QyKRdMdB"};